'use strict';

export const fa = {
    name: 'fa',
    closeText: 'بستن',
    prevText: '&#x3C;قبلی',
    nextText: 'بعدی&#x3E;',
    currentText: 'امروز',
    monthNames: ['فروردين', 'ارديبهشت', 'خرداد', 'تير', 'مرداد', 'شهريور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
    monthNamesShort: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    dayNames: ['يکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
    dayNamesShort: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
    dayNamesMin: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
    weekHeader: 'هف',
    dateFormat: 'yy/mm/dd',
    firstDay: 6,
    isRTL: !0,
    showMonthAfterYear: !1,
    yearSuffix: ''
};
